import React from 'react';
import { NavLink } from 'react-router-dom';
import './CodeGeneratorNav.css';

const CodeGeneratorNav = () => {
  return (
    <nav className="code-generator-nav">
      <NavLink 
        to="/tools/code-generator/favorites"
        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
      >
        ⭐ Favorites
      </NavLink>
      <NavLink 
        to="/tools/code-generator" 
        end
        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
      >
        ✨ New Code
      </NavLink>
      <NavLink 
        to="/tools/code-generator/jobs"
        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
      >
        ⚙️ Jobs
      </NavLink>
      <NavLink 
        to="/tools/code-generator/history"
        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
      >
        📚 History
      </NavLink>
    </nav>
  );
};

export default CodeGeneratorNav;
